import type { RouteResources } from '@atlassian/react-resource-router';
/* eslint-disable import/order */
import { MenuIdFilters } from '@jira/navigation-apps__constants/src/MenuIdFilters.tsx';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import { createLegacyEntry } from '@jira/platform__routing-route-entry/src/createLegacyEntry.tsx';
import type { JiraLegacyRoute } from '@jira/platform__routing-route-types/src/JiraLegacyRoute.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { globalIssueNavigatorRoute } from '@jira/router-routes__legacy-global-issue-navigator-routes/src/globalIssueNavigatorRoute.tsx';
import { LegacyPageWithTeamProfileCardView } from './ui/legacy-team-profile-card-view/index.tsx';

export const globalIssueNavigatorRouteEntry: JiraLegacyRoute<RouteResources> = createLegacyEntry(
	globalIssueNavigatorRoute,
	() => ({
		apdexIgnoreParams: ['issueKey'],
		canTransitionIn: () => false,
		// eslint-disable-next-line no-restricted-syntax
		component: LegacyPageWithTeamProfileCardView,
		layout: globalLayout,
		navigation: {
			menuId: MenuIdFilters,
		},
		resources: [...getNavigationResources(), navigationSidebarGlobalResource],
	}),
);
